import React from 'react'
import { Global, css } from '@emotion/react'
import MontserratRegular from './fonts/Montserrat-Regular.ttf'
import MontserratThin from './fonts/Montserrat-Thin.ttf'
import MontserratMedium from './fonts/Montserrat-Medium.ttf'
import MontserratSemiBold from './fonts/Montserrat-SemiBold.ttf'
import MontserratBold from './fonts/Montserrat-Bold.ttf'

export const GlobalStyles = (props) => {
  return (
    <Global
      styles={css`
        @font-face {
          font-family: 'RemServ';
          src: local('RemServ'), url(${MontserratRegular}) format('truetype');
        }

        @font-face {
          font-family: 'RemServ';
          src: local('RemServ'), url(${MontserratThin}) format('truetype');
          font-weight: 100;
        }

        @font-face {
          font-family: 'RemServ';
          src: local('RemServ'), url(${MontserratMedium}) format('truetype');
          font-weight: 700;
        }

        @font-face {
          font-family: 'RemServ';
          src: local('RemServ'), url(${MontserratMedium}) format('truetype');
          font-weight: 550;
        }

        @font-face {
          font-family: 'RemServ';
          src: local('RemServ'), url(${MontserratSemiBold}) format('truetype');
          font-weight: 800;
        }

        @font-face {
          font-family: 'RemServ';
          src: local('RemServ'), url(${MontserratBold}) format('truetype');
          font-weight: 900;
        }

        @font-face {
          font-family: 'RemServ';
          src: local('RemServ'), url(${MontserratBold}) format('truetype');
          font-weight: bold;
        }

        body {
          font-family: RemServ, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
            'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
            'Noto Color Emoji';
          word-break: break-word;
        }
        // general.scss styles are moved here please remove whichever is not required in future
        input[type='number']::-webkit-inner-spin-button,
        input[type='number']::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        .font-weight-bold {
          font-weight: 800 !important;
        }
        .text-underline {
          text-decoration: underline !important;
          color: ${props.theme.colors.primary};
        }

        .text-positive {
          color: ${props.theme.colors.positive};
        }

        .text-green {
          color: ${props.theme.colors.alertGreen} !important;
        }

        .background-green {
          background: ${props.theme.colors.alertGreen2} !important;
        }

        .text-header {
          font-weight: 700;
          text-transform: uppercase;
        }

        .text-brand {
          color: ${props.theme.colors.primary};
        }

        .text-dark {
          color: ${props.theme.colors.textLightblack};
        }

        .clickable {
          cursor: pointer;
        }

        // text sizes

        .text-smaller {
          font-size: ${props.theme.font.size.smaller};
        }
        .text-small {
          font-size: ${props.theme.font.size.small};
        }
        .text-medium {
          font-size: ${props.theme.font.size.medium} !important;
        }
        .text-larger {
          font-size: ${props.theme.font.size.larger};
        }
        .text-largest {
          font-size: ${props.theme.font.size.largest};
        }

        //forms
        .errorMsg {
          font-size: 18px;
          color: red;
          padding: 5px 0;
          display: none;
        }

        .show {
          display: block;
        }

        //please remove if component specific

        //banner

        .banner-bg {
          position: relative;
          width: 100%;
          overflow-y: hidden !important;
          overflow-x: hidden !important;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: right;
          padding: 37px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          .banner-container {
            max-width: 1046px;
            width: 100%;
          }

          .banner-content {
            word-break: initial;
            color: ${props.theme.colors.white};
            width: 100%;
            p {
              font-size: 20px;
              font-weight: bold;
              max-width: 660px;
              line-height: 36px;
            }
          }

          .banner-content.theme-dark {
            color: ${props.theme.colors.textDarkblack};
            h2 {
              text-transform: initial;
            }
          }
        }

        // margin and paddings

        .mb-13rem {
          margin-bottom: 1.3rem;
        }

        .mb-24 {
          margin-bottom: 24px;
        }

        //summarySection.js

        .mb-12 {
          margin-bottom: 12px;
        }

        .pl-14 {
          padding-left: 14px;
        }

        //financialInclusionSection.js
        .ui-list-a {
          padding-left: 50px;
          position: relative;
          .ui-list-icon {
            position: absolute;
            top: 0;
            left: 15px;
          }
        }

        //cardRowItem.js
        .text-indictive-color {
          color: ${props.theme.colors.grey2};
        }
        //home contebtSection.js
        .bg-grey-secondary {
          background: ${props.theme.colors.lightBackground};
        }
        .text-grey-a {
          color: ${props.theme.colors.textDarkblack};
        }
        .bg-brand,
        .bg-brand:hover {
          background: ${props.theme.colors.primary};
          background-color: ${props.theme.colors.primary};
          border-color: ${props.theme.colors.primary};
        }

        .btn.bg-brand:hover {
          opacity: 0.9;
        }

        //contactUsDialog.js
        .pd-40 {
          padding: 40px;
        }

        .width-100perc {
          width: 100%;
        }

        .terms-conditions {
          padding: 72px 0;
          border-top: 1px solid #cccccc;
          border-bottom: 1px solid #cccccc;
          li {
            margin-bottom: 18px;
          }
        }

        .card-shadow {
          box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.16);
          -webkit-box-shadow: 0px px 16px rgba(0, 0, 0, 0.16);
        }
      `}
    />
  )
}
